const isoToFlagEmoji = (iso2) =>
    iso2.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt()));

const RAW_COUNTRY_CODES = [
    { name: "Afghanistan", dialCode: "+93", iso2: "AF" },
    { name: "Albania", dialCode: "+355", iso2: "AL" },
    { name: "Algeria", dialCode: "+213", iso2: "DZ" },
    { name: "Andorra", dialCode: "+376", iso2: "AD" },
    { name: "Angola", dialCode: "+244", iso2: "AO" },
    { name: "Argentina", dialCode: "+54", iso2: "AR" },
    { name: "Armenia", dialCode: "+374", iso2: "AM" },
    { name: "Australia", dialCode: "+61", iso2: "AU" },
    { name: "Austria", dialCode: "+43", iso2: "AT" },
    { name: "Azerbaijan", dialCode: "+994", iso2: "AZ" },
    { name: "Bahamas", dialCode: "+1", iso2: "BS" },
    { name: "Bahrain", dialCode: "+973", iso2: "BH" },
    { name: "Bangladesh", dialCode: "+880", iso2: "BD" },
    { name: "Barbados", dialCode: "+1", iso2: "BB" },
    { name: "Belarus", dialCode: "+375", iso2: "BY" },
    { name: "Belgium", dialCode: "+32", iso2: "BE" },
    { name: "Belize", dialCode: "+501", iso2: "BZ" },
    { name: "Benin", dialCode: "+229", iso2: "BJ" },
    { name: "Bhutan", dialCode: "+975", iso2: "BT" },
    { name: "Bolivia", dialCode: "+591", iso2: "BO" },
    { name: "Bosnia and Herzegovina", dialCode: "+387", iso2: "BA" },
    { name: "Botswana", dialCode: "+267", iso2: "BW" },
    { name: "Brazil", dialCode: "+55", iso2: "BR" },
    { name: "Brunei", dialCode: "+673", iso2: "BN" },
    { name: "Bulgaria", dialCode: "+359", iso2: "BG" },
    { name: "Burkina Faso", dialCode: "+226", iso2: "BF" },
    { name: "Burundi", dialCode: "+257", iso2: "BI" },
    { name: "Cambodia", dialCode: "+855", iso2: "KH" },
    { name: "Cameroon", dialCode: "+237", iso2: "CM" },
    { name: "Canada", dialCode: "+1", iso2: "CA" },
    { name: "Cape Verde", dialCode: "+238", iso2: "CV" },
    { name: "Central African Republic", dialCode: "+236", iso2: "CF" },
    { name: "Chad", dialCode: "+235", iso2: "TD" },
    { name: "Chile", dialCode: "+56", iso2: "CL" },
    { name: "China", dialCode: "+86", iso2: "CN" },
    { name: "Colombia", dialCode: "+57", iso2: "CO" },
    { name: "Comoros", dialCode: "+269", iso2: "KM" },
    { name: "Congo", dialCode: "+242", iso2: "CG" },
    { name: "Costa Rica", dialCode: "+506", iso2: "CR" },
    { name: "Croatia", dialCode: "+385", iso2: "HR" },
    { name: "Cuba", dialCode: "+53", iso2: "CU" },
    { name: "Cyprus", dialCode: "+357", iso2: "CY" },
    { name: "Czech Republic", dialCode: "+420", iso2: "CZ" },
    { name: "Denmark", dialCode: "+45", iso2: "DK" },
    { name: "Djibouti", dialCode: "+253", iso2: "DJ" },
    { name: "Dominica", dialCode: "+1", iso2: "DM" },
    { name: "Dominican Republic", dialCode: "+1", iso2: "DO" },
    { name: "Ecuador", dialCode: "+593", iso2: "EC" },
    { name: "Egypt", dialCode: "+20", iso2: "EG" },
    { name: "El Salvador", dialCode: "+503", iso2: "SV" },
    { name: "Equatorial Guinea", dialCode: "+240", iso2: "GQ" },
    { name: "Eritrea", dialCode: "+291", iso2: "ER" },
    { name: "Estonia", dialCode: "+372", iso2: "EE" },
    { name: "Eswatini", dialCode: "+268", iso2: "SZ" },
    { name: "Ethiopia", dialCode: "+251", iso2: "ET" },
    { name: "Fiji", dialCode: "+679", iso2: "FJ" },
    { name: "Finland", dialCode: "+358", iso2: "FI" },
    { name: "France", dialCode: "+33", iso2: "FR" },
    { name: "Gabon", dialCode: "+241", iso2: "GA" },
    { name: "Gambia", dialCode: "+220", iso2: "GM" },
    { name: "Georgia", dialCode: "+995", iso2: "GE" },
    { name: "Germany", dialCode: "+49", iso2: "DE" },
    { name: "Ghana", dialCode: "+233", iso2: "GH" },
    { name: "Greece", dialCode: "+30", iso2: "GR" },
    { name: "Grenada", dialCode: "+1", iso2: "GD" },
    { name: "Guatemala", dialCode: "+502", iso2: "GT" },
    { name: "Guinea", dialCode: "+224", iso2: "GN" },
    { name: "Guinea-Bissau", dialCode: "+245", iso2: "GW" },
    { name: "Guyana", dialCode: "+592", iso2: "GY" },
    { name: "Haiti", dialCode: "+509", iso2: "HT" },
    { name: "Honduras", dialCode: "+504", iso2: "HN" },
    { name: "Hong Kong", dialCode: "+852", iso2: "HK" },
    { name: "Hungary", dialCode: "+36", iso2: "HU" },
    { name: "Iceland", dialCode: "+354", iso2: "IS" },
    { name: "India", dialCode: "+91", iso2: "IN" },
    { name: "Indonesia", dialCode: "+62", iso2: "ID" },
    { name: "Iran", dialCode: "+98", iso2: "IR" },
    { name: "Iraq", dialCode: "+964", iso2: "IQ" },
    { name: "Ireland", dialCode: "+353", iso2: "IE" },
    { name: "Israel", dialCode: "+972", iso2: "IL" },
    { name: "Italy", dialCode: "+39", iso2: "IT" },
    { name: "Jamaica", dialCode: "+1", iso2: "JM" },
    { name: "Japan", dialCode: "+81", iso2: "JP" },
    { name: "Jordan", dialCode: "+962", iso2: "JO" },
    { name: "Kazakhstan", dialCode: "+7", iso2: "KZ" },
    { name: "Kenya", dialCode: "+254", iso2: "KE" },
    { name: "Kiribati", dialCode: "+686", iso2: "KI" },
    { name: "Kuwait", dialCode: "+965", iso2: "KW" },
    { name: "Kyrgyzstan", dialCode: "+996", iso2: "KG" },
    { name: "Laos", dialCode: "+856", iso2: "LA" },
    { name: "Latvia", dialCode: "+371", iso2: "LV" },
    { name: "Lebanon", dialCode: "+961", iso2: "LB" },
    { name: "Lesotho", dialCode: "+266", iso2: "LS" },
    { name: "Liberia", dialCode: "+231", iso2: "LR" },
    { name: "Libya", dialCode: "+218", iso2: "LY" },
    { name: "Liechtenstein", dialCode: "+423", iso2: "LI" },
    { name: "Lithuania", dialCode: "+370", iso2: "LT" },
    { name: "Luxembourg", dialCode: "+352", iso2: "LU" },
    { name: "Macau", dialCode: "+853", iso2: "MO" },
    { name: "Madagascar", dialCode: "+261", iso2: "MG" },
    { name: "Malawi", dialCode: "+265", iso2: "MW" },
    { name: "Malaysia", dialCode: "+60", iso2: "MY" },
    { name: "Maldives", dialCode: "+960", iso2: "MV" },
    { name: "Mali", dialCode: "+223", iso2: "ML" },
    { name: "Malta", dialCode: "+356", iso2: "MT" },
    { name: "Mauritania", dialCode: "+222", iso2: "MR" },
    { name: "Mauritius", dialCode: "+230", iso2: "MU" },
    { name: "Mexico", dialCode: "+52", iso2: "MX" },
    { name: "Moldova", dialCode: "+373", iso2: "MD" },
    { name: "Monaco", dialCode: "+377", iso2: "MC" },
    { name: "Mongolia", dialCode: "+976", iso2: "MN" },
    { name: "Montenegro", dialCode: "+382", iso2: "ME" },
    { name: "Morocco", dialCode: "+212", iso2: "MA" },
    { name: "Mozambique", dialCode: "+258", iso2: "MZ" },
    { name: "Myanmar", dialCode: "+95", iso2: "MM" },
    { name: "Namibia", dialCode: "+264", iso2: "NA" },
    { name: "Nauru", dialCode: "+674", iso2: "NR" },
    { name: "Nepal", dialCode: "+977", iso2: "NP" },
    { name: "Netherlands", dialCode: "+31", iso2: "NL" },
    { name: "New Zealand", dialCode: "+64", iso2: "NZ" },
    { name: "Nicaragua", dialCode: "+505", iso2: "NI" },
    { name: "Niger", dialCode: "+227", iso2: "NE" },
    { name: "Nigeria", dialCode: "+234", iso2: "NG" },
    { name: "North Korea", dialCode: "+850", iso2: "KP" },
    { name: "North Macedonia", dialCode: "+389", iso2: "MK" },
    { name: "Norway", dialCode: "+47", iso2: "NO" },
    { name: "Oman", dialCode: "+968", iso2: "OM" },
    { name: "Pakistan", dialCode: "+92", iso2: "PK" },
    { name: "Palau", dialCode: "+680", iso2: "PW" },
    { name: "Palestine", dialCode: "+970", iso2: "PS" },
    { name: "Panama", dialCode: "+507", iso2: "PA" },
    { name: "Papua New Guinea", dialCode: "+675", iso2: "PG" },
    { name: "Paraguay", dialCode: "+595", iso2: "PY" },
    { name: "Peru", dialCode: "+51", iso2: "PE" },
    { name: "Philippines", dialCode: "+63", iso2: "PH" },
    { name: "Poland", dialCode: "+48", iso2: "PL" },
    { name: "Portugal", dialCode: "+351", iso2: "PT" },
    { name: "Qatar", dialCode: "+974", iso2: "QA" },
    { name: "Romania", dialCode: "+40", iso2: "RO" },
    { name: "Russia", dialCode: "+7", iso2: "RU" },
    { name: "Rwanda", dialCode: "+250", iso2: "RW" },
    { name: "Saint Lucia", dialCode: "+1", iso2: "LC" },
    { name: "Samoa", dialCode: "+685", iso2: "WS" },
    { name: "San Marino", dialCode: "+378", iso2: "SM" },
    { name: "Saudi Arabia", dialCode: "+966", iso2: "SA" },
    { name: "Senegal", dialCode: "+221", iso2: "SN" },
    { name: "Serbia", dialCode: "+381", iso2: "RS" },
    { name: "Seychelles", dialCode: "+248", iso2: "SC" },
    { name: "Sierra Leone", dialCode: "+232", iso2: "SL" },
    { name: "Singapore", dialCode: "+65", iso2: "SG" },
    { name: "Slovakia", dialCode: "+421", iso2: "SK" },
    { name: "Slovenia", dialCode: "+386", iso2: "SI" },
    { name: "Solomon Islands", dialCode: "+677", iso2: "SB" },
    { name: "Somalia", dialCode: "+252", iso2: "SO" },
    { name: "South Africa", dialCode: "+27", iso2: "ZA" },
    { name: "South Korea", dialCode: "+82", iso2: "KR" },
    { name: "South Sudan", dialCode: "+211", iso2: "SS" },
    { name: "Spain", dialCode: "+34", iso2: "ES" },
    { name: "Sri Lanka", dialCode: "+94", iso2: "LK" },
    { name: "Sudan", dialCode: "+249", iso2: "SD" },
    { name: "Suriname", dialCode: "+597", iso2: "SR" },
    { name: "Sweden", dialCode: "+46", iso2: "SE" },
    { name: "Switzerland", dialCode: "+41", iso2: "CH" },
    { name: "Syria", dialCode: "+963", iso2: "SY" },
    { name: "Taiwan", dialCode: "+886", iso2: "TW" },
    { name: "Tajikistan", dialCode: "+992", iso2: "TJ" },
    { name: "Tanzania", dialCode: "+255", iso2: "TZ" },
    { name: "Thailand", dialCode: "+66", iso2: "TH" },
    { name: "Timor-Leste", dialCode: "+670", iso2: "TL" },
    { name: "Togo", dialCode: "+228", iso2: "TG" },
    { name: "Tonga", dialCode: "+676", iso2: "TO" },
    { name: "Trinidad and Tobago", dialCode: "+1", iso2: "TT" },
    { name: "Tunisia", dialCode: "+216", iso2: "TN" },
    { name: "Turkey", dialCode: "+90", iso2: "TR" },
    { name: "Turkmenistan", dialCode: "+993", iso2: "TM" },
    { name: "Tuvalu", dialCode: "+688", iso2: "TV" },
    { name: "Uganda", dialCode: "+256", iso2: "UG" },
    { name: "Ukraine", dialCode: "+380", iso2: "UA" },
    { name: "United Arab Emirates", dialCode: "+971", iso2: "AE" },
    { name: "United Kingdom", dialCode: "+44", iso2: "GB" },
    { name: "United States", dialCode: "+1", iso2: "US" },
    { name: "Uruguay", dialCode: "+598", iso2: "UY" },
    { name: "Uzbekistan", dialCode: "+998", iso2: "UZ" },
    { name: "Vanuatu", dialCode: "+678", iso2: "VU" },
    { name: "Vatican City", dialCode: "+379", iso2: "VA" },
    { name: "Venezuela", dialCode: "+58", iso2: "VE" },
    { name: "Vietnam", dialCode: "+84", iso2: "VN" },
    { name: "Yemen", dialCode: "+967", iso2: "YE" },
    { name: "Zambia", dialCode: "+260", iso2: "ZM" },
    { name: "Zimbabwe", dialCode: "+263", iso2: "ZW" },
];

export const countryCodes = RAW_COUNTRY_CODES.map((country) => ({
    ...country,
    flag: isoToFlagEmoji(country.iso2),
    flagUrl: `https://flagcdn.com/${country.iso2.toLowerCase()}.svg`,
}));

export default countryCodes;
